import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../../auth/registered/SEC_00_DB_Payload";

/**
 * 🛰️ KNOWLEDGE BASE ASSISTANT — service
 * ----------------------------------------------------------------------------
 * Plain-English Q&A answered ONLY from the Knowledge Base corpus
 * (ESG.KnowledgeDocument / _Chunk, .claude/db/create_knowledge_base.sql).
 * Same shape as prec-med's QA, minus the audit trail — nothing is logged.
 *
 * Routed by the BFF Doorman as intent "KnowledgeAsk" so the retrieval + LLM
 * call runs on a Function-URL Lambda (not the 29s API Gateway path):
 *   /api/v1/sustina/knowledge-base/ask
 * Backend (chunk retrieval + grounded generation + citation check) is the
 * outstanding piece; until it exists the panel degrades gracefully.
 */
const ENDPOINT = "/api/v1/sustina/knowledge-base/ask";

export const askKnowledgeBase = async ({ question, companyId }, config) => {
  const raw = await dbPayload(
    ENDPOINT,
    "POST",
    config.siteKey,
    GoldenSourceHelper.prepareForApi({
      action: "ASK_KNOWLEDGE_BASE",
      question: (question || "").trim(),
      companyId: companyId || null,
    }),
    "KnowledgeAsk",
  );
  const res = GoldenSourceHelper.normalize(raw);
  if (!res.success) {
    throw new Error(res.message || "The knowledge base assistant is unavailable.");
  }
  const d = res.data || {};
  return {
    answer: d.answer || d.Answer || "",
    refused: !!(d.refused ?? d.Refused),
    refusalReason: d.refusalReason || d.RefusalReason || "",
    model: d.model || d.Model || "",
    citations: (d.citations || d.Citations || []).map((c) => ({
      name: GoldenSourceHelper.get(c, "Name") || GoldenSourceHelper.get(c, "DocName") || "",
      section:
        GoldenSourceHelper.get(c, "Section") ??
        GoldenSourceHelper.get(c, "ChunkIndex") ??
        null,
      effectiveDate: GoldenSourceHelper.get(c, "EffectiveDate") || null,
      quote: GoldenSourceHelper.get(c, "Quote") || GoldenSourceHelper.get(c, "BodyText") || "",
      score: GoldenSourceHelper.get(c, "Score") ?? null,
    })),
  };
};
